import { CloudAccountType } from '@repo/api-gw-sdk';
import { useState } from 'react';

import { useDAL } from '@/contexts/useDAL';

import { useAccountRoleName } from './useAccountRoleName';

export const URLS: Record<CloudAccountType, string> = {
  [CloudAccountType.Source]:
    'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/source-account.yml',
  [CloudAccountType.Vault]:
    'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/eon-vault-verification-role.yml',
  [CloudAccountType.Restore]:
    'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/restore-account.yml',
  [CloudAccountType.Scanning]:
    'https://eon-public-b2b628cc-1d96-4fda-8dae-c3b1ad3ea03b.s3.amazonaws.com/scanning-account.yml',
  [CloudAccountType.AccountTypeUnspecified]: '',
};

export const useCreateAwsAccount = (
  accountType: CloudAccountType.Source | CloudAccountType.Restore,
  onDone: (accountId: string) => void
) => {
  const dal = useDAL();
  const [accountId, setAccountId] = useState('');
  const [roleName, setRoleName] = useAccountRoleName(accountType);
  const [isCreationInProgress, setIsCreationInProgress] = useState(false);
  const [isCreated, setIsCreated] = useState(false);
  const [hasError, setHasError] = useState(false);

  const createAccount = async () => {
    setIsCreationInProgress(true);

    try {
      let id = '';
      if (accountType === CloudAccountType.Restore) {
        const { restoreAccount } = await dal.cloudAccounts.restore.connect.aws({
          role: `arn:aws:iam::${accountId}:role/${roleName}`,
          name: accountId,
        });
        id = restoreAccount.id;
      } else if (accountType === CloudAccountType.Source) {
        const { sourceAccount } = await dal.cloudAccounts.source.connect.aws({
          role: `arn:aws:iam::${accountId}:role/${roleName}`,
          name: accountId,
        });
        id = sourceAccount.id;
      }
      onDone(id);
      setIsCreated(true);
    } catch {
      setHasError(true);
    } finally {
      setIsCreationInProgress(false);
    }
  };

  return {
    accountId,
    setAccountId,
    roleName,
    setRoleName,
    isCreationInProgress,
    isCreated,
    hasError,
    setHasError,
    retry: () => setHasError(false),
    createAccount,
  };
};
